module.exports = __webpack_public_path__ + "img/드래곤슬레이어.215422a1.png";